import styled from "styled-components";
import { Container } from "../layout/Container";
import ContactInfoCards from "./ContactInfoCards";
import ContactForm from "./ContactForm";

const Section = styled.section`
  padding: 2.5rem 0 3rem;
`;

const Grid = styled.div`
  display: grid;
  gap: 2rem;
  max-width: min(100%, 90rem);
  margin: 0 auto;
  @media (min-width: 768px) {
    grid-template-columns: 1fr 2fr;
  }
`;

export default function ContactPageBody() {
  return (
    <Section>
      <Container>
        <Grid>
          <ContactInfoCards />
          <ContactForm />
        </Grid>
      </Container>
    </Section>
  );
}
